import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { cx } from '@emotion/css';

import { Button } from '@phoenix/design-system/frontend/ui/button/button';
import { ProductCompatibleBatteries } from '@phoenix/team-m/dashboard/frontend/util/product/product-batteries.model';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';

import { CompatibleBatteriesCard } from './compatible-batteries-card';
import { useLoadMoreItems } from '@phoenix/team-m/dashboard/frontend/shared/use-load-more-items';

const plusIcon = getDesignSystemIcon('icon-plus-16.svg');

interface CompatibleBatteriesCatalogProps {
  batteries: ProductCompatibleBatteries[];
  className?: string;
}

export const CompatibleBatteriesCatalog: FC<CompatibleBatteriesCatalogProps> = ({ batteries, className }) => {
  const { t } = useTranslation();
  const { items, onClickLoadMore, isLastPage } = useLoadMoreItems(batteries);

  return (
    <div className={cx('flex flex-col gap-6 desktop:gap-0', className)} data-testid="compatible-batteries-catalog">
      <div className="hidden rounded-t-lg border border-secondary-mid bg-primary-white stihl-text-body-sm-bold desktop:grid desktop:grid-cols-3">
        <div className="col-span-1 px-8 py-6">{t('dashboard_batteries_teaser_table_label_yourProduct')}</div>
        <div className="col-span-2 px-8 py-6">{t('dashboard_batteries_teaser_table_label_compatibleBatteries')}</div>
      </div>
      {items.map((product: ProductCompatibleBatteries, index: number) => (
        <CompatibleBatteriesCard
          key={product.articleNumber}
          product={product}
          className={cx('rounded-lg desktop:rounded-none desktop:border-t-0', { 'desktop:rounded-b-lg': index + 1 === items.length })}
        />
      ))}
      {!isLastPage && (
        <Button
          iconPosition="left"
          icon={plusIcon}
          onClick={onClickLoadMore}
          btnType="white_default"
          className="m-auto mt-6"
          data-testid="load-more-compatible-batteries"
        >
          {t('dashboard_batteries_button_loadMore')}
        </Button>
      )}
    </div>
  );
};
